const getField =
    (containerEl, cssPrefix, fieldName, inputTag) => {
        if (containerEl.querySelector(cssPrefix + '[data-field=' + '"' + fieldName + '"] ' + inputTag)) {
            return isNaN(parseFloat(containerEl.querySelector(cssPrefix + '[data-field=' + '"' + fieldName + '"] ' + inputTag).value)) ?
                containerEl.querySelector(cssPrefix + '[data-field=' + '"' + fieldName + '"] ' + inputTag).value
                : parseFloat(containerEl.querySelector(cssPrefix + '[data-field=' + '"' + fieldName + '"] ' + inputTag).value);
        } else {
            return 0;
        }
    }

const getInputsForBroker = (containerEl, brokerId) => {
    const cssPrefix = '.fxcalculator__input-section [data-broker="' + brokerId.toString() + '"] ';

    const data = {
        'currency': getField(containerEl, cssPrefix, 'currency', 'select'),
        'swap_long': getField(containerEl, cssPrefix, 'swap-long', 'input[type="number"]'),
        'swap_short': getField(containerEl, cssPrefix, 'swap-short', 'input[type="number"]'),
        'swap_type': getField(containerEl, cssPrefix, 'swap-type', 'select'),
        'digits': getField(containerEl, cssPrefix, 'digits', 'input[type="number"]'),
        'contract_size': getField(containerEl,cssPrefix, 'contract-size', 'input[type="number"]'),
        'price_span': getField(containerEl, cssPrefix, 'price-span', 'input[type="number"]'),
        'leverage': getField(containerEl, cssPrefix, 'leverage', 'input[type="number"]'),
        'stop_out': getField(containerEl, cssPrefix, 'stop-out', 'input[type="number"]'),
        'spread': getField(containerEl, cssPrefix, 'spread', 'input[type="number"]'),
        'broker': getField(containerEl, cssPrefix, 'broker', 'input[type="text"]'),
        'triple_day': getField(containerEl, cssPrefix, 'triple-day', 'select')
    }

    return data;
}

export {
    getInputsForBroker,
}